/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation DeleteBeneficiaryMutation($input: DeleteBeneficiary_M_simulation_customer_granteesInput!) {
    deleteBeneficiary_M_simulation_customer_grantees(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
